import styled from 'styled-components';

export const StyledFormTitle = styled.h2`
  margin-bottom: 0.7rem;
  line-height: 3.5rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
`;

export const StyledFormSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.text.lighter};
`;
